<script>
  import { transactionStore } from '../../stores'
  import { config } from '../../../scripts/defaultURL'
  import DeleteTransactionModal from './DeleteTransaction.svelte'
  import { formatPayloadDate, openModal } from '../../../scripts/functions'
  import { updateData } from '../../../scripts/rest'

  export let transaction
  export let categoryOptions

  let deleteTransactionModal = false
  let date = transaction.date ? transaction.date.split('T')[0] : '';
  let amount = transaction.amount || 0;
  let description = transaction.description || '';
  let category = transaction.category || '';

  function closeModal() {
    document.getElementById('editTransactionModal')?.classList.remove('is-active')

    transactionStore.update((store) => {
      const currentStore = store || {}
      currentStore['todo'] = 'getData'
      return currentStore
    })
  }

  async function save(e) {
    e.preventDefault()

    const payload = {
      id: transaction.id,
      amount: Number(amount) || 0,
      category,
      client_id: transaction.client_id ?? null,
      date: formatPayloadDate(date),
      description,
      income_expense: transaction.income_expense,
    }

    console.log('Sending payload:', payload)

    try {
      const res = await updateData(
        `${config.defaultURL}/transactions/update/${payload.id}`,
        payload
      )
      console.log('Update response:', res)
      closeModal()
    } catch (err) {
      console.error('Failed to update:', err)
    }
  }

  function deleteTransaction(item) {
    console.log('transaction:', item)
    deleteTransactionModal = true

    openModal('deleteTransactionModal')
  }
</script>

<div class="modal" id="editTransactionModal">
  <div class="modal-background" />
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit transaction</p>
      <button on:click={closeModal} class="delete" aria-label="close" />
    </header>
    <section class="modal-card-body">
      <form on:submit|preventDefault={save}>
        <div class="field">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="label">Date</label>
          <input
            id="date"
            bind:value={date}
            class="input"
            type="date"
            required
          />
        </div>
        <div class="field">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="label">Amount</label>
          <div style="display:flex;">
            <div style="padding-top:8px;">$</div>
            <div style="width:100%; padding-left:5px;">
              <input
                id="amount"
                bind:value={amount}
                class="input"
                type="text"
              />
            </div>
          </div>
        </div>
        <div class="field">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="label">Description</label>
          <textarea id="description" bind:value={description} class="textarea"
          ></textarea>
        </div>
        <div class="field">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="label">Category</label>
          <input
            id="category"
            list="categories"
            bind:value={category}
            class="input"
            placeholder="Category (optional)"
          />
          <datalist id="categories">
            {#each categoryOptions as category}
              <option>{category}</option>
            {/each}
          </datalist>
        </div>
        <div class="field is-grouped">
          <div class="control">
            <button class="button is-primary" type="submit">Save</button>
          </div>
          <div class="control">
            <button
              type="button"
              class="button is-danger"
              on:click={() => {
                deleteTransaction(transaction)
              }}>Delete</button
            >
          </div>
          <div class="control">
            <button
              type="reset"
              on:click={closeModal}
              class="button is-primary is-light">Cancel</button
            >
          </div>
        </div>
      </form>
    </section>
  </div>
</div>
{#if deleteTransactionModal}
  <DeleteTransactionModal {transaction} />
{/if}

<style>
  .modal-card-title {
    margin-bottom: 0 !important;
  }
</style>
